module.exports = __webpack_public_path__ + "img/shopping_banner02.60dcbde2.png";